import './styles/gojs.css';
import * as go from 'gojs';
import {
  createGraphLinksModel,
  createBaseDiagram,
} from './diagram/diagramConfig';
import { configureLinkingTool } from './diagram/linkingConfig';
import { registerDiagramListeners } from './diagram/diagramListeners';
import { connectionHandler } from './model/connectionHandler';

const $ = go.GraphObject.make;

let model = $(go.GraphLinksModel, {
  nodeKeyProperty: 'key',
  linkKeyProperty: 'key',
  linkFromPortIdProperty: 'fromPort',
  linkToPortIdProperty: 'toPort',
});

let diagramInstance: go.Diagram | null = null;

export const getDiagram = (): go.Diagram | null => {
  return diagramInstance;
};

export const createDiagram = () => {
  if (diagramInstance) {
    return diagramInstance;
  }

  model = createGraphLinksModel();
  const diagram = createBaseDiagram(model);
  configureLinkingTool(diagram);
  registerDiagramListeners(diagram);

  diagram.addModelChangedListener(function (evt) {
    if (!evt.isTransactionFinished) return;
    const txn = evt.object;
    if (txn === null) return;
    txn.changes.each(function (e: go.ChangedEvent) {
      if (
        e.modelChange === 'linkDataArray' ||
        e.modelChange === 'linkToPortId' ||
        e.modelChange === 'linkFromPortId'
      ) {
        connectionHandler(e);
      }
    });
  });

  diagramInstance = diagram;
  return diagram;
};

export type { CreateNodeDataArray } from './utils/dataArrays';
export { createNodeDataArray } from './utils/dataArrays';
export { createLinkDataArray } from './utils/dataArrays';
export type { UndoFromPortInterface, UndoToPortInterface } from './model/types';
export { handleModelChange } from './model/modelHandlers';

export {
  checkIfUnitExist,
  checkIfUnitIsACopy,
  checkIfLinkIsACopy,
  findCorrectFromPortIndex,
  findCorrectToPortIndex,
  checkIfLinkExist,
} from './utils/unitChecks';
